import { render } from "./articleComponent.vue?vue&type=template&id=587a3f08&scoped=true"
import script from "./articleComponent.vue?vue&type=script&lang=js"
export * from "./articleComponent.vue?vue&type=script&lang=js"

import "./articleComponent.vue?vue&type=style&index=0&id=587a3f08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587a3f08"]])

export default __exports__